module.exports = __webpack_public_path__ + "img/tongTool.e69c1947.png";